module.exports = __webpack_public_path__ + "static/insight-5--hero-46a430a504ec590d296ba489b0140b40.png";